import { useTheme } from '../contexts/ThemeContext';

export const useThemeColors = () => {
  const { theme } = useTheme();
  const isLight = theme === 'light';

  // Your original colors (unchanged)
  const baseColors = {
    background: isLight ? '#f8f8f8' : '#121212',
    surface: isLight ? '#ffffff' : '#1e1e1e',
    surface1: isLight ? '#1e1e1e' : '#ffffff',
    primary: isLight ? '#333333' : '#ffffff',
    secondary: isLight ? '#666666' : '#e0e0e0',
    accent: isLight ? '#888888' : '#888888',
    accent1: isLight ? 'rgba(211, 211, 211, 0.86)' : 'rgba(131, 131, 131, 0.82)',
    border: isLight ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)',
    glass: isLight ? 'rgba(255, 255, 255, 0.7)' : 'rgba(30, 30, 30, 0.7)',
    text: isLight ? '#333333' : '#ffffff',
    icon: isLight ? '#333333' : '#ffffff',
  };

  // New variants
  const variantColors = {
    // Surface variants
    surfaceVariant: isLight ? '#f0f0f0' : '#2a2a2a',
    surfaceElevated: isLight ? '#ffffff' : '#242424',
    
    // Inverse colors (swap light/dark values)
    inverseBackground: isLight ? '#121212' : '#f8f8f8',
    inverseSurface: isLight ? '#1e1e1e' : '#ffffff',
    inverseText: isLight ? '#ffffff' : '#333333',
    inverseIcon: isLight ? '#ffffff' : '#333333',
    
    // Additional variants for better theming
    textSecondary: isLight ? '#666666' : '#b3b3b3',
    borderStrong: isLight ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)',
    skillHover: isLight ? '#888888' : '#aaaaaa',

    // Text variants
    textVariant: isLight ? '#555555' : '#b3b3b3',
    textDisabled: isLight ? '#aaaaaa' : '#4d4d4d',
    
    // Border variants
    borderVariant: isLight ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)',
    borderInverse: isLight ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',

        glassElevated: isLight ? 'rgba(255, 255, 255, 0.85)' : 'rgba(40, 40, 40, 0.85)',
  };

  return { 
    ...baseColors,    // Your original colors
    ...variantColors, // New additions
    isLight          // Helper boolean
  };
};

export { useTheme };